import { useEffect, useRef } from "react";
import { shouldRemountHeraldChatInstance } from "@/lib/utils/heraldChatUtils";

/**
 * Bumps the `useChat` id when the thread identity changes. Call after `useChat` so
 * `messages` / `initialMessages` lengths are available.
 */
export const useHeraldChatInstanceRemountEffect = (input: {
  conversationId: string | undefined;
  capturedConversationId: string | null;
  getTransportConversationId: () => string | null;
  messagesLength: number;
  initialMessagesLength: number;
  setChatInstanceId: (id: string) => void;
}): void => {
  const {
    conversationId,
    capturedConversationId,
    getTransportConversationId,
    messagesLength,
    initialMessagesLength,
    setChatInstanceId,
  } = input;

  const prevConversationIdForChatInstanceRef = useRef<string | undefined>(
    conversationId,
  );

  useEffect(() => {
    const prev = prevConversationIdForChatInstanceRef.current;
    const cur = conversationId;
    const shouldBump = shouldRemountHeraldChatInstance({
      prevConversationId: prev,
      conversationId: cur,
      transportConversationId: getTransportConversationId(),
      messagesLength,
      initialMessagesLength,
    });
    if (shouldBump) {
      setChatInstanceId(`herald-${crypto.randomUUID()}`);
    }
    prevConversationIdForChatInstanceRef.current = cur;
  }, [
    conversationId,
    capturedConversationId, // Re-evaluate when transport captures a new conversation id.
    getTransportConversationId,
    messagesLength,
    initialMessagesLength,
    setChatInstanceId,
  ]);
};
